import React, { useState, useEffect } from 'react';
import Header from './Header.jsx';
import './Header.css'
import './Feed.css';
import twitch from '../assets/twitch.png';
import { Link, useNavigate } from 'react-router-dom';
import PostingList from './PostingList.jsx';
import Post from './Post.jsx';
import CensorProfanity from './ProfanityCensor';
import translations from './translation.js';
import arrow from '../assets/arrow_up.png';



const TopStreams = ({ defaultGameId }) => {

  const [topStreams, setTopStreams] = useState([]);
  const [selectedGame, setSelectedGame] = useState(defaultGameId);
  const [first, setFirst] = useState(5);
  const currentLanguage = localStorage.getItem('selectedLanguage') || "en";
  const gameOptions = [
    { id: '511224', name: translations[currentLanguage].apex_legends },
    { id: '32399', name: translations[currentLanguage].counter_strike },
    { id: '29595', name: translations[currentLanguage].dota_2 },
    { id: '33214', name: translations[currentLanguage].fortnite },
    { id: '32982', name: translations[currentLanguage].grand_theft_auto_v },
    { id: '21779', name: translations[currentLanguage].league_of_legends },
    { id: '27471', name: translations[currentLanguage].minecraft },
    { id: '23020', name: translations[currentLanguage].roblox },
    { id: '513143', name: translations[currentLanguage].teamfight_tactics },
    { id: '516575', name: translations[currentLanguage].valorant },
  ];

  const fetchTopStreams = async () => {
    try {
      const response = await fetch(
        `https://api.twitch.tv/helix/streams?game_id=${selectedGame}&first=${first}`,
        {
          headers: {
            'Client-ID': process.env.REACT_APP_TWITCH_CLIENT_ID,
            'Authorization': `Bearer ${process.env.REACT_APP_TWITCH_AUTHORIZATION}`
          }
        }
      );
      const data = await response.json();
      setTopStreams(data.data);
    } catch (error) {
      console.error('Error fetching top streams:', error);
    }
  };

  useEffect(() => {
    fetchTopStreams();
  }, [selectedGame, first]);


  const loadMoreStreams = () => {
    setFirst(prevFirst => prevFirst + 5);
  };

  return (
    <div className='holder'>

      <br />

      <select
        className="game-select"
        value={selectedGame}
        onChange={(e) => setSelectedGame(e.target.value)}
      >
        {gameOptions.map((game) => (
          <option key={game.id} value={game.id}>
            {game.name}
          </option>
        ))}
      </select>

      <br />
      <br />

      <div id='video-container'>
        {topStreams.map((stream) => (
          <div key={stream.id} style={{ marginBottom: '20px' }}>
            <iframe
              src={`https://player.twitch.tv/?channel=${stream.user_name}&parent=webdev.cse.buffalo.edu&muted=true`}
              height="300"
              width="100%"
              frameBorder="0"
              scrolling="no"
              allowFullScreen={true}
              style={{ borderRadius: '10px' }}
            ></iframe>
            <br />
          </div>
        ))}
      </div>
      <br />
      <button className='load_more_button' onClick={loadMoreStreams}>{translations[currentLanguage].load_more}</button>
    </div>
  );
};

const Feed = ({ appRefresh }) => {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [memberOf, setMemberOf] = useState([]);
  const [memberOfNames, setMemberOfNames] = useState([]);
  const [profanityFilter, setProfanityFilter] = useState(false);
  const navigate = useNavigate();
  const currentLanguage = localStorage.getItem('selectedLanguage') || "en";
  const [val, setVal] = useState("");
  const handleValue = (val) => { setVal(val); };
  const [filteredPosts, setFilteredPosts] = useState([]);

  useEffect(() => {
    filterPosts();
  }, [val, posts]);

  const filterPosts = () => {
    console.log("filter");
    console.log(val);
    if (val !== null && val !== '' && val !== '@') {
      let filteredPosts = posts.filter(post => {
        if (val.startsWith('@')) {
          const usernameFilter = val.slice(1).toLowerCase();
          return post.author && post.author.attributes && post.author.attributes.username &&
            post.author.attributes.username.toLowerCase().includes(usernameFilter);
        } else {
          return post.content.toLowerCase().includes(val.toLowerCase()) ||
            post.attributes.title.toLowerCase().includes(val.toLowerCase());
        }
      });
      setFilteredPosts(filteredPosts);
    } else {
      setFilteredPosts(posts);
    }
  };
  const fetchUserData = async () => {
    try {
      const userResponse = await fetch(
        `${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem('user')}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
        }
      );
      if (userResponse.ok) {
        const userResult = await userResponse.json();
        setProfanityFilter(userResult.attributes.ProfanityFilter)
      } else {
        console.error('Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  console.log(currentLanguage);
  console.log(translations[currentLanguage].load_more);
  // get posts from all users (excluding comments, dms, and group messages)
  const loadPosts = () => {
    if (sessionStorage.getItem("token")) {
      fetch(`${process.env.REACT_APP_API_PATH}/posts?recipientUserID=&parentID=`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => res.json())
        .then((result) => {
          if (result) {
            result[0] = result[0].filter(post => !post.attributes.hidden);
            setIsLoaded(true);
            if (memberOf.length > 0) {
              let filteredPosts = [];
              for (let i = 0; i < result[0].length; i++) {
                if (memberOf.includes(result[0][i].recipientGroupID)) {
                  filteredPosts.push(result[0][i]);
                }
              }
              setPosts(filteredPosts);
            } else {
              setPosts(result[0]);
            }
          }
        })
        .catch((err) => {
          setIsLoaded(true);
          setError(err);
          console.log("ERROR loading posts");
        });
    }
  };

  // get all communities user is a member of in memberOf
  const getMemberOf = () => {
    if (sessionStorage.getItem("token")) {
      fetch(`${process.env.REACT_APP_API_PATH}/group-members?userID=${sessionStorage.getItem("user")}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => res.json())
        .then((result) => {
          // get recipientGroupIDs and put them in a list
          console.log(result);
          let isMemberOf = [];
          let names = []
          for (let i = 0; i < result[0].length; i++) {
            isMemberOf.push(result[0][i].groupID);
            names.push(parseName(result[0][i].group.name));
          }
          setMemberOf(isMemberOf);
          setMemberOfNames(names);
          console.log("isMemberOf:", names);
        })
    }

    function parseName(name) {
      console.log("namecommunity:", name);
      // hardcoded for each community
      switch (name) {
        case "FPScommunity": return { "name": "FPS", "link": "fps" }
        case "BattleRoyaleCommunity": return { "name": "Battle-Royale", "link": "battle-royale" }
        case "ActionAdventureCommunity": return { "name": "Action-Adventure", "link": "action-adventure" }
        case "MOBACommunity": return { "name": "MOBA", "link": "moba" }
        case "SandboxCommunity": return { "name": "Sandbox", "link": "sandbox" }
      }
    }
  };

  useEffect(() => {
    loadPosts();
    fetchUserData();
  }, [memberOf]);

  useEffect(() => {
    getMemberOf();
    if (!sessionStorage.getItem("token")) {
      navigate("/");
    }
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  const translateCommunity = (name) => {
    console.log("name:",name);
    switch (name) {
      case "FPS": return translations[currentLanguage].community1;
      case "Battle-Royale": return translations[currentLanguage].community2;
      case "Action-Adventure": return translations[currentLanguage].community5;
      case "MOBA": return translations[currentLanguage].community3;
      case "Sandbox": return translations[currentLanguage].community4;
    }
  };
  const showCommunities = (memberOfNames) => {
    if (memberOfNames.length == 0) {
      return (
        <Link to="/discover" id="find-com-btn">{translations[currentLanguage].find_community}</Link>
      )
    } else {
      return (
        <div className="com-list">
          {memberOfNames.map((namePair) => (
            console.log("names:",namePair),
            <Link to={`/games/${namePair["link"]}`}>{translateCommunity(namePair["name"])}</Link>
          ))}
        </div>
      )
    }
  }

  const CensorProfanity = (text) => {
    console.log("pro:",profanityFilter);
    console.log(text);
    if (!profanityFilter) {
      return text;
    }
    // Replace profane words with asterisks or other characters
    return text.replace(/\b(fuck|hell|shit|bitch)\b/gi, "****");
  };
  return (
    <>
      <Header onValue={handleValue} />
      <h1>{translations[currentLanguage].your_feed}</h1>
      <div className="content">
        <main>
          <PostingList
            refresh={appRefresh}
            posts={filteredPosts.map(post => ({
              ...post,
              content: CensorProfanity(post.content)
            }))}

            error={error}
            isLoaded={isLoaded}
            type="postlist"
            loadPosts={loadPosts}
          />

          <Link to="/postform"><button id="make-post-btn">+ {translations[currentLanguage].make_post} </button></Link>
        </main>

        <aside className='feed'>
          <div id="show-communities">
            <h2>{translations[currentLanguage].your_communities}</h2>
            {/* <div className="com-list">
              {memberOfNames.map((name) => (
                <Link to="/games/">{name}</Link>
              ))}
            </div> */}
            {showCommunities(memberOfNames)}
          </div>
          <div id="twitch-feed">
            <img src={twitch} alt="twitch logo" id="twitch-logo" />
            <p id="twitch-text"> {translations[currentLanguage].twitch_text} </p>
            <TopStreams defaultGameId="21779" />
            <button className="scroll_to_top" id="scroll-to-top" onClick={scrollToTop}>
              <img src={arrow} alt="Scroll Up" className="arrow-up-icon" />
            </button>
          </div>
        </aside>
      </div>
    </>
  );
};

export default Feed;
